import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-purchase-record",
  "use": "icon-purchase-record-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-purchase-record\"><path d=\"M850.9 97.8H173.1c-32 0-56.5 24.5-56.5 56.5v715.5c0 32 24.5 56.5 56.5 56.5h677.8c32 0 56.5-24.5 56.5-56.5V154.3c0-32-24.5-56.5-56.5-56.5zM737.9 399c-7.5 94.1-124.3 169.5-225.9 169.5S293.6 493.2 286.1 399c-22.6-3.8-37.7-22.6-37.7-47.1 0-26.4 20.7-47.1 47.1-47.1 26.4 0 47.1 20.7 47.1 47.1 0 15.1-7.5 28.2-18.8 37.7 0 77.2 105.4 141.2 188.3 141.2s188.3-64 188.3-141.2c-11.3-9.4-18.8-22.6-18.8-37.7 0-26.4 20.7-47.1 47.1-47.1 26.4 0 47.1 20.7 47.1 47.1-0.2 22.7-17.1 41.5-37.9 47.1z\" p-id=\"19509\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/purchase-record.svg
// module id = BUn5
// module chunks = 65